import OT, { Publisher } from "@opentok/client";

import { Dispatch, SetStateAction, useEffect } from "react";

const useScreenShareListener = (
  session: (OT.Session & { streams?: OT.Stream[] }) | null,
  setShareScreen: Dispatch<
    SetStateAction<{ isSharing: boolean; publisher: Publisher | null }>
  >
) => {
  useEffect(() => {
    if (!session) return;

    const handleStreamCreated = (event: any) => {
      const { stream } = event;

      if (
        stream.videoType !== "screen" ||
        stream.connection.connectionId === session.connection?.connectionId
      ) {
        return;
      }

      let screenContainer = document.getElementById("screen-preview");
      if (!screenContainer) {
        const publisherWrapper = document.getElementById(
          "meeting-room-videos-area"
        );
        if (!publisherWrapper) return;

        screenContainer = document.createElement("div");
        screenContainer.id = "screen-preview";
        screenContainer.style.width = "100%";
        screenContainer.style.height = "100%";
        screenContainer.style.position = "absolute";
        publisherWrapper.appendChild(screenContainer);
        setShareScreen({
          isSharing: true,
          publisher: null,
        });
      }

      session.subscribe(
        stream,
        screenContainer.id,
        {
          insertMode: "append",
          width: "100%",
          height: "100%",
          showControls: false,
        },
        (error) => {
          if (error) {
            console.error("Error subscribing to screen share:", error);
          }
        }
      );
    };

    session.on("streamCreated", handleStreamCreated);
    session.on("streamDestroyed", () => {
      setShareScreen({
        isSharing: false,
        publisher: null,
      });
    });

    return () => {
      session.off("streamCreated", handleStreamCreated);
    };
  }, [session]);
};

export default useScreenShareListener;
